// Opens the header's sign-in dialog from anywhere on the page: a control that
// needs an account (the Library home's "Create Library") dispatches it instead
// of carrying a dialog of its own.
export const AUTH_OPEN_LOGIN_EVENT = 'auth:open-login';
